export const list = {
  input: {
    list_id: {
      label: 'Список'
    }
  },

  state: {
    init: {
      description: `Позволяет отфильтровать входящие звонки по номеру. Удобно использовать для организации черных списков или списков VIP-клиентов. Новый список номеров можно добавить в личном кабинете, в разделе`
    }
  }
};
